import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const QuestionLibrary = {
    state: () => ({
        items: [],
        timeout: null,
        filter: {
            searchTerm: null,
            skip: 0,
            take: 10000,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
    }),
    mutations: {
        setQuestionLibrary(state, payload) {
            var dammyLibrary = [];
            payload.items.map((x) => {
                dammyLibrary.push({...x, show: false });
            });
            state.items = dammyLibrary;

            state.filter.total = payload.total;
        },
        setSelectedQuestionLibrary(state, payload) {
            state.selectedItems = payload;
        },
        setQuestionLibraryPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getQuestionLibrary');
        },
        setQuestionLibraryTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getQuestionLibrary');
        },
    },
    actions: {
        async getQuestionLibraryItem(context, payload) {
            var res = await axios.post('/QuestionLibrary/Get', { id: payload });
            return res;
        },
        async saveQuestionsOrders(context, payload) {
            var res = await axios.post('/QuestionLibrary/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async getQuestionLibrary(store) {
            var res = await axios.post('questionlibrary/load', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                store.commit('setQuestionLibrary', res.data.data);
            }
        },
        async toggleQuestionLibrary(store, payload) {
            var res = await axios.post('questionlibrary/toggleisactive', {
                id: payload,
            });
            return res.data;
        },
        async deleteQuestionLibrary(store, payload) {
            var res = await axios.post('questionlibrary/delete', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default QuestionLibrary;


// WEBPACK FOOTER //
// ./src/store/questionlibrary.js